/// <reference types="@angular/localize" />

import './prototypes/array/reduceObjectKeys'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule }              from '@app/app.module';
import { AppInjector }            from '@app/core/services/app-injector.service';
import { APP_MODE }               from '@appConfig/app-mode-config';
import { APP_CONFIG }             from '@appConfig/_app-config_master';

platformBrowserDynamic().bootstrapModule( AppModule )
.then( ( moduleRef ) => {
	AppInjector.setInjector( moduleRef.injector );
} )
.catch( err => {
	if ( APP_CONFIG.appMode === APP_MODE.LOCAL ) {
		console.error( err );
	}
} );
